import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiRoute } from "services";
import API from "services/lib/api";
import { dataQueryStatus } from "utils";
// import { getErrorMessage } from "utils/helper";
import EmptyInfo from "components/ui/Empty/EmptyInfo/EmptyInfo";
import { otherCategories } from "components/dashboard/AgentInbox/enum";
import ChatModule from "./ChatModule/ChatModule";
import CustomerTicketsContainer from "./CustomerTicketsContainer/CustomerTicketsContainer";
import TicketDetail from "./TicketDetails/TicketDetail";
import CloseTicket from "./ChatModule/CloseTicket/CloseTicket";
import { deleteIncomingTicket, pushIncomingTickets, setIncomingTickets } from "store/tickets/incomingTickets/actions";
import * as types from "store/ticketsFilters/types";

import { motion, AnimatePresence } from "framer-motion";
import TicketsFilterGroup from "../TicketsFilterGroup/TicketsFilterGroup";
// import { setActiveTicket } from "store/tickets/actions";
import "./ChatTickets.scss";
import { getErrorMessage } from "utils/helper";
import { selectNextTicket } from "./CustomerTicketsContainer/CustomerTickets/util/helper";
import { setActiveTicket } from "store/tickets/actions";

const { IDLE, DATAMODE, LOADING, ERROR } = dataQueryStatus;
const { EXTERNAL_EMAILS } = otherCategories;

const ChatTickets = ({
    reconnectUser,
    refreshData,
    setTicketData,
    handleRefreshData,
    showFilters,
    toggleFilters,
    handleToggleEmailPreview,
    selectedTicketHeader,
    setSelectedTicketHeader,
    refetchEmails,
    handleSuccess,
    selectedCannedEmail,
    showEmailPreview,
    emailAction,
    emailPreviewValue,
    toggleEmailPreview,
    ticketData,
    handleRemoveEmailPreview,
    selectAgentGuide,
}) => {
    const { ticketsfilterRequest } = useSelector((state) => state?.ticketsFilters);

    const { ticketInfoValue, messageTagId, agentId, lastModified, search } = ticketsfilterRequest;
    const { incomingTickets } = useSelector((state) => state?.incomingTickets);

    const { activeTicket: selectedTicket } = useSelector(
        (state) => state?.tickets
    );
    const { currentPage } = ticketsfilterRequest;

    const [status, setStatus] = useState(IDLE);
    const [fetchMessagesStatus, setFetchMessageStatus] = useState(IDLE);

    const [errorMssg, setErrorMssg] = useState("");
    const [showTicketActionModal, toggleTicketActionModal] = useState(false);
    const [showClipboard, toggleEmailClipboard] = useState(false);

    const [recentCustomerMessage, setRecentCustomerMessage] = useState("");
    const [investigativeCustomerMessage, setInvestigativeCustomerMessage] = useState("");
    const [selectedCustomerMessage, selectCustomerMessage] = useState({});

    const [ticketToClose, setTicketToClose] = useState({});
    const [cannedMessage, setCannedMessage] = useState("");
    const [attachments, setAttachments] = useState({
        fileAttachments: [],
        ticketAttachment: {},
    });

    const dispatch = useDispatch();

    const abortControllerRef = useRef(null);

    const handleToggleTicketActionModal = (ticket) => {
        toggleTicketActionModal(true);
        setTicketToClose(ticket);
    };

    const handleToggleEmailAttachment = (attachmentType, attachmentData) => {
        // toggleEmailAttachment(true);

        setSelectedTicketHeader(EXTERNAL_EMAILS);
        toggleEmailPreview(true);

        setAttachments((prev) => ({
            ...prev,
            [attachmentType]: attachmentData,
        }));

    };

    const toggleClipboardAndAttachment = (attachmentType) => {
        setSelectedTicketHeader(EXTERNAL_EMAILS);
        toggleEmailClipboard(true)
    }

    const handleTicketSuccess = (shouldDelete = true) => {
        selectNextTicket(
            ticketToClose,
            incomingTickets,
            (nextTicket, ticketId) => {
                dispatch(setActiveTicket(nextTicket));
                if (shouldDelete && ticketId) {
                    dispatch(deleteIncomingTicket({ ticketId }));
                }
                toggleTicketActionModal(false);
                setTicketToClose({});
            }
        );
    };

    const fetchAllTickets = async (search) => {
        try {
            
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            
            abortControllerRef.current = new AbortController();

            if(currentPage === 1){
                setStatus(LOADING);
                setErrorMssg(null);
            }else{
                dispatch({ type: types.SET_TICKETS_LOADING, payload: true });
            }
           
            const url = apiRoute?.getTicketsByPagination;
            
            const res = await API.get(url, {
                params: {
                    ...ticketsfilterRequest
                },
                signal: abortControllerRef.current.signal
            });

            if (abortControllerRef.current?.signal.aborted) {
                return;
            }

            if (res?.status === 200 && res?.data) {
                const { data: tickets, metaData } = res.data;
              
                const hasMore = metaData.currentPage * metaData.pageSize < metaData.totalRecords;

                dispatch({ type: types.SET_TICKETS_LOADING, payload: false });
                dispatch({
                    type: types.SET_TICKETS_META,
                    payload: { totalRecords: metaData.totalRecords, hasMore}
                });

                if (metaData.currentPage === 1) {
                    dispatch(setIncomingTickets(tickets));
                } else {
                    dispatch(pushIncomingTickets([...tickets]));
                }

                handleRemoveEmailPreview();
                setStatus(DATAMODE);
            }
        } catch (err) {
            if (err.name === 'AbortError' || err.name === 'CanceledError') {
                return;
            }
            if(currentPage === 1){
                setStatus(ERROR);
                setErrorMssg(getErrorMessage(err));
            }
            dispatch({ type: types.SET_TICKETS_LOADING, payload: false });
            
        } finally {
            if (abortControllerRef.current) {
                abortControllerRef.current = null;
            }
        }
    };


    const clearSelectedCustomerMessage = () => {
        selectCustomerMessage({});
    };

    useEffect(() => {
        if (ticketInfoValue || messageTagId || agentId || search) {
            fetchAllTickets();
        }
        setCannedMessage("");

        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, ticketInfoValue, messageTagId, lastModified, refreshData, agentId, search]);




    return (
        <div className='chat__ticket__container'>
            <div className='col-8 pe-0'>
                <TicketsFilterGroup
                    {...{
                        showFilters,
                        toggleFilters,
                        refreshData,
                        handleRefreshData,
                        selectedTicketHeader,
                    }}
                />
                <div className='chat__ticket--section'>
                    <div className='container-fluid h-100'>
                        <div className='row h-100'>
                            <div className='col-4 pe-0'>
                                <CustomerTicketsContainer
                                    status={status}
                                    errorMssg={errorMssg}
                                    handleRetry={fetchAllTickets}
                                    handleRemoveEmailPreview={
                                        handleRemoveEmailPreview
                                    }
                                    selectedTicketHeader={selectedTicketHeader}
                                    clearSelectedCustomerMessage={clearSelectedCustomerMessage}
                                />
                            </div>
                            <div className='col-8 px-0'>
                                <AnimatePresence exitBeforeEnter>
                                    <motion.div
                                        className={`chat__container`}
                                        key={
                                            selectedTicket !== null
                                                ? selectedTicket?.ticketId
                                                : "empty"
                                        }
                                        initial={{ x: 10, opacity: 0 }}
                                        animate={{ x: 0, opacity: 1 }}
                                        exit={{ x: -10, opacity: 0 }}
                                        transition={{ duration: 0.5 }}>
                                        {selectedTicket !== null &&
                                            selectedTicket !== undefined ? (
                                            <ChatModule
                                                ticket={selectedTicket}
                                                setRecentCustomerMessage={
                                                    setRecentCustomerMessage
                                                }
                                                toggleTicketActionModal={(
                                                    ticket
                                                ) =>
                                                    handleToggleTicketActionModal(
                                                        ticket
                                                    )
                                                }
                                                key={selectedTicket?.ticketId}
                                                setTicketData={setTicketData}
                                                reconnectUser={reconnectUser}
                                                handleSuccess={
                                                    handleRefreshData
                                                }
                                                cannedMessage={cannedMessage}
                                                setCannedMessage={
                                                    setCannedMessage
                                                }
                                                showFilters={showFilters}
                                                attachments={attachments}
                                                {...{
                                                    handleSuccess,
                                                    showEmailPreview,
                                                    emailAction,
                                                    emailPreviewValue,
                                                    toggleEmailPreview,
                                                    ticketData,
                                                    setSelectedTicketHeader,
                                                    setInvestigativeCustomerMessage,
                                                    setFetchMessageStatus,
                                                    selectedCustomerMessage,
                                                    selectCustomerMessage,
                                                    toggleClipboardAndAttachment,
                                                    handleToggleEmailAttachment
                                                }}
                                            />
                                        ) : (
                                            <EmptyInfo
                                                otherClassNames={"with-margin"}
                                                message={`No conversation started yet,\n click on a tag above to begin`}
                                            />
                                        )}
                                    </motion.div>
                                </AnimatePresence>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-4 ps-0'>
                <TicketDetail
                    recentCustomerMessage={recentCustomerMessage}
                    fetchAllTickets={fetchAllTickets}
                    setCannedMessage={setCannedMessage}
                    handleToggleEmailPreview={handleToggleEmailPreview}
                    handleToggleEmailAttachment={handleToggleEmailAttachment}
                    selectedTicketHeader={selectedTicketHeader}
                    setSelectedTicketHeader={setSelectedTicketHeader}
                    refetchEmails={refetchEmails}
                    selectedCannedEmail={selectedCannedEmail}
                    selectedEmailData={emailPreviewValue}
                    selectAgentGuide={selectAgentGuide}
                    attachments={attachments}
                    fetchMessagesStatus={fetchMessagesStatus}
                    investigativeCustomerMessage={investigativeCustomerMessage}
                    selectedCustomerMessage={selectedCustomerMessage}
                    showClipboard={showClipboard}
                    toggleEmailClipboard={toggleEmailClipboard}
                />
            </div>
            {showTicketActionModal && (
                <CloseTicket
                    show={showTicketActionModal}
                    closeModal={() => toggleTicketActionModal(false)}
                    handleSuccess={handleTicketSuccess}
                    ticketToClose={ticketToClose}
                />
            )}
        </div>
    );
};

export default ChatTickets;
